<template>
  <div class="spaceCenter">
    <div class="exchange-card" v-loading="loading">
      <div class="exchange-tab-box">
        <el-tabs v-model="activeName">
          <el-tab-pane name="Exchange">
            <span slot="label"><i class="iconfont trn-duihuan"></i> Exchange</span>
          </el-tab-pane>
          <el-tab-pane label="Buyback" name="Buyback">
            <span slot="label"><i class="iconfont trn-huigou"></i> Repurchase</span>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="exchange-tab-body">
        <div class="spaceBetween" style="margin-bottom: 0.13rem">
          <span class="word-sm" style="color:#929DAD;">
            <img src="@/assets/image/exchange/jiantou.svg" style="width:0.16rem;"/>
            1 {{ activeName == "Exchange" ? "UNIT" : "TCash" }} = ${{ unitPrice }}
          </span>
          <span class="word-sm" style="color:#DCE0E7;">
            Balance : <big-number :number.sync="balance"/>
          </span>
        </div>
        <div class="spaceBetween exchange-item">
          <div class="spaceLeft">
            <img v-if="activeName == 'Exchange'" src="@/assets/image/exchange/unit.png"
                 style="width:0.44rem;margin-right:0.16rem;"/>
            <img v-else src="@/assets/image/exchange/ustn.png" style="width:0.44rem;margin-right:0.16rem;"/>
            <div>
              <div class="word-sm-black">
                {{ activeName == "Exchange" ? "UNIT" : "TCash" }}
              </div>
              <span class="word-sm" style="color:#56627A;">From</span>
            </div>
          </div>
          <div>
            <el-input class="exchange-input" placeholder="0.00" v-model="exchangeNum" @change="exchangeInput"/>
            <div class="text-right word-sm-num">$ {{ changeMoney }}</div>
          </div>
        </div>
        <img class="exchange-jiantou" src="@/assets/image/exchange/down.png"/>
        <div class="spaceBetween exchange-item">
          <div class="spaceLeft">
            <img v-if="activeName == 'Exchange'" src="@/assets/image/exchange/ustn.png"
                 style="width:0.44rem;margin-right:0.16rem;"/>
            <img v-else src="@/assets/image/exchange/unit.png" style="width:0.44rem;margin-right:0.16rem;"/>
            <div>
              <div class="word-sm-black">
                {{ activeName == "Exchange" ? "TCash" : "UNIT" }}
              </div>
              <span class="word-sm" style="color:#56627A;">To</span>
            </div>
          </div>
          <div>
            <div class="word-big-num text-right">
              <big-number :number.sync="exchangeRes"/>
            </div>
          </div>
        </div>
        <div class="spaceBetween" style="margin-top:0.88rem;">
          <span class="word-sm" style="color:#929DAD;">Maximum exchangeable</span>
          <div>
            <span class="word-sm-num" style="color:#DCE0E7;">
              <big-number :number.sync="maximum"/>
            </span>
            <span class="word-sm">{{ activeName == "Exchange" ? "TCash" : "UNIT" }}</span>
          </div>
        </div>
        <checkLoginBtn @clickHandle="submit" style="margin-top:0.2rem"/>
      </div>
    </div>
  </div>
</template>

<script>
import checkLoginBtn from "@/components/CheckLoginBtn/index.vue";
import {toBigNum, toBigItem} from "@/utils/bigNumberTran.js";
import BigNumber from "bignumber.js";
import {isIntNum} from "@/utils/index.js"

export default {
  components: {checkLoginBtn},
  data() {
    return {
      loading: false,
      activeName: "Exchange",
      balance: 0,
      unitPrice: 0,
      exchangeNum: undefined,
      maximum: 0,
      exchangeRes: undefined,
      unit_price: 0,
      ustn_price: 0,
    };
  },
  computed: {
    account() {
      return this.$store.getters.metaMaskObj.account;
    },
    changeMoney() {
      return (this.unitPrice * (+this.exchangeNum || 0)).toFixed(2);
    }
  },
  methods: {
    async init() {
      try {
        this.loading = true;
        this.exchangeNum = undefined;
        this.exchangeRes = undefined;

        this.contractUSTN = this.$store.getters.contractMap["contractUSTN"].contract;
        this.contractUSTNAddress = this.$store.getters.contractMap["contractUSTN"].address;
        this.contractUnitPrice = this.$store.getters.contractMap["contractUnitPrice"].contract;
        this.contractUnitPriceAddress = this.$store.getters.contractMap["contractUnitPrice"].address;

        this.getBalance();
        this.getUnitPrice();
        this.getMaximum();
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    async getBalance() {
      try {
        if (this.activeName == "Exchange") {
          this.balance = await web3.eth.getBalance(this.account);
        } else {
          this.balance = await this.contractUSTN.methods["balanceOf"](
            this.account
          ).call({
            from: this.account
          });
        }
      } catch (e) {
        console.log("getBalance--", e);
      }
    },
    async getUnitPrice() {
      try {
        let price = await this.contractUnitPrice.methods[
          "getCurrencyValue"
          ](this.activeName == "Exchange" ? this.UNITVal : this.USTNVal).call({
          from: this.account
        });
        this.unitPrice = new BigNumber(price).div(new BigNumber(10000)).toNumber()
        console.log(this.unitPrice)
      } catch (e) {
        console.log("getUnitPrice--", e);
      }
    },
    async getMaximum() {
      try {
        // debugger
        let res = await this.contractUSTN.methods["totalSupply"]().call({
          from: this.account
        });
        console.log("res=====", res)
        let total_supply = new this.BigNumber(res);
        let max_ustn = new this.BigNumber(5e+25);

        let ustn_price = await this.contractUnitPrice.methods["getCurrencyValue"](this.USTNVal).call({
          from: this.account
        });
        let unit_price = await this.contractUnitPrice.methods["getCurrencyValue"](this.UNITVal).call({
          from: this.account
        });

        this.ustn_price = ustn_price;
        this.unit_price = unit_price;

        let l_max = new this.BigNumber(ustn_price).div(new this.BigNumber(10000)).times(total_supply);
        let max_exchange_ustn = max_ustn
        if (l_max.comparedTo(max_ustn) > 0) {
          max_exchange_ustn = l_max;
        }
        console.log(max_exchange_ustn.toNumber());

        if (this.activeName == "Exchange") {
          let z = max_exchange_ustn.minus(total_supply);
          if (z.comparedTo(0) < 0) {
            this.maximum = 0;
          } else {
            this.maximum = z.toNumber();
          }
        } else {
          let z = total_supply.minus(max_exchange_ustn)
          if (z.comparedTo(0) < 0) {
            this.maximum = 0;
          } else {
            this.maximum = z.times(ustn_price).div(unit_price).toNumber();
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    checkNumber() {
      if (!isIntNum(+this.exchangeNum)) {
        this.$message.warning(`Please enter a number`);
        return false;
      }

      if (this.exchangeNum <= 0 || !this.exchangeNum) {
        this.$message.warning("Please enter a value greater than 0");
        this.exchangeNum = undefined;
        return false;
      }
      if (toBigItem(this.exchangeNum).comparedTo(this.balance) > 0) {
        this.$message.warning("Insufficient UNIT balance");
        return false;
      }
      if (this.activeName == "Exchange" && toBigItem(this.exchangeNum).comparedTo(this.maximum) > 0) {
        this.$message.warning("Insufficient maximum exchangeable");
        return false;
      }
      if (this.activeName == "Buyback" && toBigItem(this.exchangeNum).times(this.ustn_price).div(this.unit_price).comparedTo(this.maximum) > 0) {
        this.$message.warning("Insufficient maximum exchangeable");
        return false;
      }
      return true;
    },
    async exchangeInput() {
      this.loading = true;
      if (!this.checkNumber()) {
        this.loading = false;
        return;
      }

      try {
        let methodName =
          this.activeName == "Exchange" ? "mintRate" : "mintBackRate";
        if (new BigNumber(this.maximum).comparedTo(0) <= 0) {
          this.$confirm(
            "This operation can only be performed when the maximum exchangeable is greater than 0",
            "warning",
            {
              confirmButtonText: "ok",
              showCancelButton: false,
              type: "warning"
            }
          ).then(() => {
          });
          this.loading = false;
          return;
        }

        this.exchangeRes = await this.contractUSTN.methods[methodName](
          toBigNum(this.exchangeNum)
        ).call({
          from: this.account
        });
      } catch (e) {
        this.$message.error("operation failed!");
        console.log(e);
      }
      this.loading = false;
    },
    async submit(btn) {
      if (!this.checkNumber()) {
        btn.closeLoad();
        return;
      }

      if (this.activeName == "Exchange") {
        const tx_builder = this.contractUSTN.methods["mint"]();
        const encoded_tx = tx_builder.encodeABI();
        web3.eth
          .sendTransaction({
            gas: this.$store.getters.gas,
            from: this.account,
            to: this.contractUSTNAddress,
            value: toBigNum(this.exchangeNum),
            data: encoded_tx
          })
          .then(res => {
            btn.closeLoad();
            this.init();
            this.refresh();
            this.$message.success("You have successfully exchange UNIT!");
          })
          .catch(error => {
            if (error.code === 4001) {
              this.$message.error(error.message)
            } else {
              this.$message.error("operation failed");
            }
            console.error(error);
            btn.closeLoad();
          });
      } else {
        let totalSupply = await this.contractUSTN.methods["totalSupply"]().call(
          {
            from: this.account
          }
        );
        /*if (new BigNumber(totalSupply).comparedTo(toBigNum(5, 26)) <= 0) {
          this.$confirm(
            "This operation can only be performed when the total circulation is greater than 5 * 10 ^ 26",
            "warning",
            {
              confirmButtonText: "ok",
              showCancelButton: false,
              type: "warning"
            }
          ).then(() => {
          });
          btn.closeLoad();
          return;
        }*/

        const tx_builder = this.contractUSTN.methods["mintBack"](toBigNum(this.exchangeNum));
        const encoded_tx = tx_builder.encodeABI();
        web3.eth
          .sendTransaction({
            gas: this.$store.getters.gas,
            from: this.account,
            to: this.contractUSTNAddress,
            data: encoded_tx
          })
          .then(res => {
            btn.closeLoad();
            this.init();
            this.refresh();
            this.$message.success("You have successfully buyback TCash!");
          })
          .catch(error => {
            if (error.code === 4001) {
              this.$message.error(error.message)
            } else {
              this.$message.error("operation failed");
            }
            console.error(error);
            btn.closeLoad();
          });
      }
    },
    refresh() {
      this.$emit("refresh");
    }
  },
  created() {
    this.init();
  },
  mounted() {
  },
  watch: {
    activeName(newVal) {
      this.init();
    }
  }
};
</script>
<style scoped lang="scss">
.exchange-card {
  padding: 0.2rem 0 0.8rem 0;
  border-radius: 0.24rem;
  background: linear-gradient(90deg, #020202 0%, #020202 42%, #00266B 100%);
  border: 0.01rem solid #272D38;
  min-width: 7.26rem;

  .exchange-tab-box {
    border-bottom: 0.02rem solid rgba(146, 157, 173, 0.2);
    padding: 0 0.4rem;
  }

  .exchange-tab-body {
    padding: 0.38rem 0.4rem 0 0.4rem;
  }

  /deep/ .el-tabs {
    .el-tabs__header {
      margin-bottom: 0;
    }

    .el-tabs__nav {
      width: 100%;

      .el-tabs__item {
        font-size: 0.24rem;
        color: #929dad;
        padding: 0.28rem 0.65rem;
        height: auto;
        width: 50%;
        text-align: center;

        &.is-active {
          color: #FFFFFF;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;

          i {
            color: #225BFC;
          }
        }
      }
    }

    .el-tabs__active-bar {
      background: #225BFC;
    }

    .el-tabs__nav-wrap::after {
      height: 0;
    }
  }

  .exchange-item {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 0.08rem;
    border: 1px solid rgba(255, 255, 255, 0.25);
    padding: 0.24rem 0.2rem;
    min-width: 5.6rem;
    margin-bottom: 0.16rem;
  }

  .exchange-jiantou {
    width: 0.56rem;
    position: absolute;
    left: 50%;
    margin-left: -0.28rem;
    margin-top: -0.34rem;
  }

  .exchange-input {
    /deep/ .el-input__inner {
      border: none;
      text-align: right;
      font-size: 0.36rem;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: #FFFFFF;
      padding: 0 0;
      background: transparent;
    }
  }

  .word-sm {
    font-size: 0.18rem;
    // font-weight: 400;
    color: #aaaaaa;
    line-height: 0.2rem;
    // margin-bottom: 0.13rem;
  }

  .word-big-num {
    font-size: 0.36rem;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 0.42rem;
  }

  .word-sm-black {
    font-size: 0.2rem;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 0.24rem;
  }

  .word-sm-num {
    color: #929DAD;
    font-size: 0.2rem;
    line-height: 0.24rem;
  }

  .common-btn-blue {
    margin-top: 0.2rem;
  }

  .iconfont {
    font-size: 0.22rem !important;
    margin-right: 0.03rem;
  }
}
</style>
